<template>
  <div class="all-son">
    <div class="table-all">
      <div class="title">
        运管部门登录统计
      </div>

      <div class="table-top">
        <span class="table-but2" @click="reset">刷新</span>
      </div>

      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          'text-align': 'center',
          'background-color': '#fafafa',
          color: 'rgba(0, 0, 0, 0.85)',
        }"
        :cell-style="{ 'text-align': 'center', color: 'rgba(0, 0, 0, 0.65)' }"
      >
        <el-table-column label="已登录">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewLoggedIn">{{
              scope.row.loggedIn
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="未登录">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewNotLogIn">{{
              scope.row.notLogIn
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-top"></div>

      <div class="title">
        海报下载量统计
      </div>

      <div class="table-top">
        <span class="table-but2" @click="reset1">刷新</span>
      </div>

      <el-table
        ref="multipleTable"
        :data="
          tableData1.slice(
            (currentPage1 - 1) * pagesize1,
            currentPage1 * pagesize1
          )
        "
        :header-cell-style="{
          'text-align': 'center',
          'background-color': '#fafafa',
          color: 'rgba(0, 0, 0, 0.85)',
        }"
        :cell-style="{ 'text-align': 'center', color: 'rgba(0, 0, 0, 0.65)' }"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="shortName" label="地区"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column label="海报下载量">
          <template slot-scope="scope">{{
            scope.row.posterDownloads == null ? 0 : scope.row.posterDownloads
          }}</template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[10, 15, 20]"
          :page-size="pagesize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="dialogTableVisible">
      <el-table
        :data="
          detailData.slice((currentPage - 1) * pagesize, currentPage * pagesize)
        "
        :header-cell-style="{
          'text-align': 'center',
          'background-color': '#fafafa',
          color: 'rgba(0, 0, 0, 0.85)',
        }"
        :cell-style="{ 'text-align': 'center', color: 'rgba(0, 0, 0, 0.65)' }"
      >
        <el-table-column property="shortName" label="地区"></el-table-column>
        <el-table-column property="name" label="名称"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 15, 20]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      objData: {
        loggedIn: 0,
        notLogIn: 0,
      },
      transportationDepartmentLoggedIn: [],
      transportationDepartmentNotLogIn: [],
      dialogTableVisible: false,
      detailData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      tableData1: [],
      multipleSelection: [],
      currentPage1: 1,
      pagesize1: 10,
      total1: 0,
    };
  },
  created() {
    this.transportationDepartmentStatistics();
    this.posterDownloadsStatistics();
  },
  methods: {
    transportationDepartmentStatistics() {
      var that = this;
      const loading = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      that.$http
        .post("/api/services/app/User/TransportationDepartmentStatistics")
        .then((res) => {
          loading.close();
          // console.log(res);
          if (res.data.success) {
            var rtnResult = res.data.result;
            that.transportationDepartmentLoggedIn =
              rtnResult.transportationDepartmentLoggedIn.transportationDepartmentStatisticsBase;
            that.transportationDepartmentNotLogIn =
              rtnResult.transportationDepartmentNotLogIn.transportationDepartmentStatisticsBase;
            that.objData.loggedIn =
              that.transportationDepartmentLoggedIn.length;
            that.objData.notLogIn =
              that.transportationDepartmentNotLogIn.length;
            that.tableData.push(that.objData);
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    reset() {
      var that = this;
      that.tableData = [];
      that.detailData = [];
      that.currentPage = 1;
      that.pagesize = 10;
      that.total = 0;
      that.transportationDepartmentStatistics();
    },
    posterDownloadsStatistics() {
      var that = this;
      const loading = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      that.$http
        .post("/api/services/app/User/PosterDownloadsStatistics")
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var rtnResult = res.data.result;
            // console.log(rtnResult);
            that.tableData1 = rtnResult;
            that.total1 = rtnResult.length;
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    reset1() {
      var that = this;
      that.tableData1 = [];
      that.multipleSelection = [];
      that.currentPage1 = 1;
      that.pagesize1 = 10;
      that.total1 = 0;
      that.posterDownloadsStatistics();
    },
    toggleSelection(rows) {
      var that = this;
      if (rows) {
        rows.forEach((row) => {
          that.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        that.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      var that = this;
      that.multipleSelection = val;
    },
    handleSizeChange(val) {
      var that = this;
      that.pagesize = val;
    },
    handleCurrentChange(val) {
      var that = this;
      that.currentPage = val;
    },
    handleSizeChange1(val) {
      var that = this;
      that.pagesize1 = val;
    },
    handleCurrentChange1(val) {
      var that = this;
      that.currentPage1 = val;
    },
    viewLoggedIn() {
      // console.log('已登录查看详细');
      var that = this;
      that.dialogTableVisible = true;
      that.detailData = that.transportationDepartmentLoggedIn;
      that.total = that.transportationDepartmentLoggedIn.length;
    },
    viewNotLogIn() {
      // console.log('未登录查看详细');
      var that = this;
      that.dialogTableVisible = true;
      that.detailData = that.transportationDepartmentNotLogIn;
      that.total = that.transportationDepartmentNotLogIn.length;
    },
  },
};
</script>

<style scoped lang="scss">


.title {
  text-align: center !important;
  font-size: 35px;
  color: black;
  font-weight: 900;
}
</style>
